import { useSelector } from "react-redux";
import OrderList from "../component/OrderList";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";
const Order = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Orders", admin?.assignedWork)) return (<AccessDenied />)

    return ( <OrderList /> )
}
export default Order;